import React, { Component } from 'react';
import Particles from 'react-particles-js';
import { Form, Icon, Input, Button, message } from 'antd';
import { connect } from 'react-redux';
import { setUserInfo } from '@/redux/actions/userInfo';
import '@/assets/css/login';
import { login } from '../services/Login';
import { setLoading } from '../redux/actions/app';

const FormItem = Form.Item;

class Login extends Component {
	state = { clientHeight: document.documentElement.clientHeight || document.body.clientHeight };

	constructor(props) {
		super(props);
		this.onResize = this.onResize.bind(this);
	}

	onLogin = e => {
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			this.props.setLoading(true);
			login(values).then(res => {
				if (res.message === 'success') {
					localStorage.setItem('token', res.data.token);
					window.location.href = '/';
				}
			}).catch(err => {
				message.error('Tên tài khoản hoặc mật khẩu không chính xác', 3);
			}).finally(() => this.props.setLoading(false));
		});
	};

	componentDidMount() {
		window.addEventListener('resize', this.onResize);
	}

	componentWillUnmount() {
		window.addEventListener('resize', this.onResize);
		this.setState = () => {
			return;
		};
	}

	onResize() {
		this.setState({ clientHeight: document.documentElement.clientHeight || document.body.clientHeight });
	}

	render() {
		const { getFieldDecorator } = this.props.form;
		return (<div className="container">
			<Particles
				height={this.state.clientHeight - 5 + 'px'}
				params={{
					number: { value: 50 }, ize: { value: 3 }, interactivity: {
						events: {
							onhover: { enable: true, mode: 'repulse' }
						}
					}
				}}
			/>
			<div className="content">
				<div className="title">Surface City</div>
				<Form className="login-form">
					<FormItem>
						{getFieldDecorator('username', {
							rules: [{ required: true, message: 'Vui lòng nhập tên tài khoản！' }]
						})(<Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
											placeholder="Tên tài khoản" />)}
					</FormItem>
					<FormItem>
						{getFieldDecorator('password', {
							rules: [{ required: true, message: 'Vui lòng nhập mật khẩu！' }]
						})(<Input.Password prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
															 placeholder="Mật khẩu" />)}
					</FormItem>
					<FormItem>
						<Button type="primary" htmlType="submit" block onClick={this.onLogin}>
							Đăng nhập
						</Button>
					</FormItem>
				</Form>
			</div>
		</div>);
	}
}

const mapStateToProps = state => state;
const mapDispatchToProps = dispatch => ({
	setUserInfo: data => {
		dispatch(setUserInfo(data));
	}, setLoading: data => {
		dispatch(setLoading(data));
	}
});
export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Login));
